import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["options", "data", "display", "period", "chartType", "yAxis", "showPoints"];

  connect() {
    this.chart = Chartkick.charts[this.data.get("chartId")];

    this.syncOptions();
    this.syncViewOptions();

    this.update(null);

    $(this.element).on("change", "input, select, textarea", (event) => {
      // Bootstrap has a bug with button toggle groups where the individual buttons are for checkboxes
      // In this scenario, the change event on the input will be fired twice; filter out one of the duplicate events
      if(!event.originalEvent && $(event.target).is(".btn-group-toggle :checkbox")) return;
      this.update(event);
    });
  }

  disconnect() {
    $(this.element).off("change");

    this.chart.destroy();
  }

  checkInput($input, state) {
    if(state) $input.prop("checked", true).parent().addClass("active");
    else $input.prop("checked", false).parent().removeClass("active");
  }

  findAndCheckInput(inputs, value) {
    this.checkInput($(inputs).filter("[value='" + value + "']"), true);
  }

  syncOptions() {
    var options = JSON.parse(this.data.get("options"));
    this.findAndCheckInput(this.dataTargets, options.data);
    this.findAndCheckInput(this.displayTargets, options.display);
    this.syncPeriod(options.period);
  }

  syncPeriod(period) {
    this.findAndCheckInput(this.periodTargets, period);
  }

  beforeUpdate() {
    $("button", this.element).attr("disabled", true);

    this.progressBar = new Turbolinks.ProgressBar();
    this.progressBar.setValue(0);
    this.progressBar.show();
  }

  afterUpdate() {
    $("button", this.element).removeAttr("disabled");
    this.progressBar.setValue(1);
    this.progressBar.hide();
  }

  syncViewOptions() {
    var options = this.chart.getOptions();
    this.findAndCheckInput(this.chartTypeTargets, this.chart.__chartName());
    this.findAndCheckInput(this.yAxisTargets, options.library.scales.yAxes[0].type);
    this.findAndCheckInput(this.showPointsTarget, options.library.scales.yAxes[0].type);
    this.checkInput($(this.showPointsTarget), options.points);
  }

  updateView() {
    this.applyChartType($(this.chartTypeTargets).filter(":checked").val());

    var options = this.chart.getOptions();
    options.library.scales.yAxes[0].type = $(this.yAxisTargets).filter(":checked").val();

    var individual = $(this.dataTargets).filter(":checked").val() == "individual";
    options.library.scales.xAxes[0].stacked = !individual;
    options.library.scales.yAxes[0].stacked = !individual;

    options.points = $(this.showPointsTarget).is(":checked");
    this.chart.setOptions(options);
  }

  applyChartType(type) {
    if(this.chart.__chartName() == type) return;
    var chartElement = this.chart.getElement();
    var chartDataSource = this.chart.getDataSource();
    var chartOptions = this.chart.getOptions();
    this.chart.destroy();
    this.chart = new Chartkick[type](chartElement, chartDataSource, chartOptions);
  }

  update(event) {
    this.beforeUpdate();

    var newUrl = this.buildUrl();
    if (window.location.href.includes('/dashboards')) {
      newUrl = newUrl.replace('/insights', '/dashboards')
    }

    if(newUrl != this.currentUrl) {
      this.currentUrl = newUrl;

      $.get(newUrl, (response) => {
        console.log(response.data)
        this.syncPeriod(response.period);
        this.chart.updateData(response.data);
        this.updateView();
        this.afterUpdate();
      });
    }
    else {
      this.updateView();
      this.afterUpdate();
    }
  }

  buildUrl() {
    var params = $("input, select, textarea", this.optionsTargets).serializeArray();
    var regexp = new RegExp("^" + this.data.get("chartId"));
    for(const param of params) param.name = param.name.replace(regexp, "");

    return this.data.get("baseUrl") + "?" + $.param(params);
  }
}
